import { webcrypto } from 'crypto'

const getSubtle = () => {
  return typeof window !== 'undefined'
    ? window.crypto.subtle
    : webcrypto.subtle
}

export const encryptAesGcm = async (plaintext, keyBytes, iv) => {
  const subtle = getSubtle()

  const key = await subtle.importKey(
    'raw',
    keyBytes,
    { name: 'AES-GCM' },
    false,
    ['encrypt', 'decrypt'],
  )

  const ciphertext = await subtle.encrypt(
    { name: 'AES-GCM', iv: iv },
    key,
    plaintext,
  )

  return new Uint8Array(ciphertext)
}

export const decryptAesGcm = async (ciphertext, keyBytes, iv) => {
  const subtle = getSubtle()

  const key = await subtle.importKey(
    'raw',
    keyBytes,
    { name: 'AES-GCM' },
    false,
    ['encrypt', 'decrypt'],
  )

  const plaintext = await subtle.decrypt(
    { name: 'AES-GCM', iv: iv },
    key,
    ciphertext,
  )

  return new Uint8Array(plaintext)
}
